import { t } from "i18next";
import React from "react";

const SuccessToast = ({ message }) => {
    return (
        <>
            <div className="alert-items-message flex">
                <div className="mt-1">
                    <i className="fas fa-check-circle icon-message"></i>
                </div>
                <div className="alert-items-title ml-3">
                    <h3>{t("success")}</h3>
                    <p>{message}</p>
                </div>
            </div>
        </>
    );
};

export default SuccessToast;
